import React from "react"
import { createRoot } from "react-dom/client"
import App from "./App"
import "../../../styles/main.css"
import i18n from "../../../i18n"
import { Provider } from "react-redux"
import { store } from "../../../app"
import { RootLayout } from "./layouts"
import AviaSearchWrapper from "./components/AviaSearchWrapper"

const mountApp = () => {
  const node = document.getElementById("avia-search-react")
  if (!node || node.dataset.mounted) return

  node.dataset.mounted = "true"

  const props = JSON.parse(node.getAttribute("data-props") || "{}")

  if (props.locale) {
    i18n.changeLanguage(props.locale)
  }

  const root = createRoot(node)
  root.render(
    <Provider store={store}>
      <RootLayout
        themeName={props?.themeName ?? "default"}
        isAdmin={props?.isAdmin}
        isPublic={props?.isPublic}
      >
        {props?.themeName === "novatravel" ? (
          <AviaSearchWrapper isPublic={props?.isPublic}>
            <App {...props} />
          </AviaSearchWrapper>
        ) : (
          <App {...props} />
        )}
      </RootLayout>
    </Provider>
  )
}

document.addEventListener("DOMContentLoaded", mountApp)
document.addEventListener("turbolinks:load", mountApp)
